var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,2.45454545 C3.63927273,2.45454545 3.27272727,2.82109091 3.27272727,3.27272727 L3.27272727,14.7272727 C3.27272727,15.1791545 3.63927273,15.5454545 4.09090909,15.5454545 C4.54254545,15.5454545 4.90909091,15.1791545 4.90909091,14.7272727 L4.90909091,10.6363636 L8.18181818,10.6363636 L8.18181818,11.4545455 C8.18181818,11.9064273 8.54836364,12.2727273 9,12.2727273 L13.9090909,12.2727273 C14.3607273,12.2727273 14.7272727,11.9064273 14.7272727,11.4545455 L14.7272727,5.72727273 C14.7272727,5.27563636 14.3607273,4.90909091 13.9090909,4.90909091 L9.81818182,4.90909091 L9.81818182,4.09090909 C9.81818182,3.63927273 9.45163636,3.27272727 9,3.27272727 L4.90909091,3.27272727 C4.90909091,2.82109091 4.54254545,2.45454545 4.09090909,2.45454545 Z M4.90909091,9 L8.18181818,9 L8.18181818,4.90909091 L4.90909091,4.90909091 L4.90909091,9 Z M9.81818182,10.6363636 L13.0909091,10.6363636 L13.0909091,6.54545455 L9.81818182,6.54545455 L9.81818182,10.6363636 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inbox-sidebar",
    transform: "translate(-373.000000, -425.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(0.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons-/-Basic-/-Flag",
    transform: "translate(370.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: ".misc-/-Fill-/-Accent-2",
    mask: "url(#mask-2)",
    fill: "#F86B67",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.f3b584402f26e9e456a0be178451292c.svg";
export { ForwardRef as ReactComponent };